import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent, getNativeProps, divProperties } from '../../Utilities';
var PivotItem = /** @class */ (function (_super) {
    tslib_1.__extends(PivotItem, _super);
    function PivotItem(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({
            linkText: 'headerText'
        });
        return _this;
    }
    PivotItem.prototype.render = function () {
        return React.createElement("div", tslib_1.__assign({}, getNativeProps(this.props, divProperties)), this.props.children);
    };
    return PivotItem;
}(BaseComponent));
export { PivotItem };
//# sourceMappingURL=PivotItem.js.map